import type { PatentProfileWithMatchedTechFeature } from '../types';

/**
 * 专利查新特征对比相似服务服务
 */
export interface NoveltySimilarService {
    /**
     * 更新查新相似列表
     */
    updateNoveltySimilarList(payload: {techFeatures: PatentProfileWithMatchedTechFeature[], isPatentConfirm?: boolean}): Promise<PatentProfileWithMatchedTechFeature[]>;

    /**
     * 获取技术特征对比得分
     */
    getFeatureComparison(payload: {pns: string[]; isAddPatent?: boolean,addPatentSelected?:boolean }): Promise<PatentProfileWithMatchedTechFeature[]>;
}

export const NoveltySimilarService = Symbol.for('NoveltySimilarService');
